import { CameraFill } from '@peacecover/icon';
import ProfileAvatar from '../../my-page/components/ProfileAvatar';
import { ReactComponent as GradientPlusProfile } from '../../../icons/gradient.plus.profile.svg';
import type { ScenePersona } from '../types';

interface AddSceneArtistsBoxProps {
  firstPersona: ScenePersona | null;
  secondPersona: ScenePersona | null;
  onAddSceneArtist: (slot: 'first' | 'second') => void;
}

const AddSceneArtistsBox = ({
  firstPersona,
  secondPersona,
  onAddSceneArtist
}: AddSceneArtistsBoxProps) => {
  const renderPersonaButton = (persona: ScenePersona | null, slot: 'first' | 'second') => {
    return (
      <button
        type="button"
        className="flex flex-col items-center gap-[12px]"
        onClick={() => onAddSceneArtist(slot)}
      >
        {persona ? (
          <div className="relative w-[88px] h-[88px]">
            {persona.dataUrl && (
              <ProfileAvatar
                thumbnailUrl={persona.dataUrl}
                widthAndHeight="88px"
                svgWidthAndHeight="56px"
              />
            )}
            <div className="absolute inset-0 pointer-events-none">
              <img
                src="/assets/icons/profile_bubble.png"
                alt="profile bubble"
                className="w-full h-full object-fill"
              />
            </div>
            <div className="absolute bottom-[6px] right-[6px] p-[2px] bg-textPrimary-dark rounded-full border-[2px] border-[#161616]">
              <CameraFill size={10} className="text-background-dark" />
            </div>
          </div>
        ) : (
          <GradientPlusProfile />
        )}
        <p className="text-onPrimary text-[12px] font-medium leading-[14px]">
          {persona?.nickname ?? '추가하기'}
        </p>
      </button>
    );
  };

  return (
    <div className="mt-[24px] flex items-center gap-[35px] px-[24px] py-[26px]">
      {renderPersonaButton(firstPersona, 'first')}
      <MaterialSymbolCloseIcon />
      {renderPersonaButton(secondPersona, 'second')}
    </div>
  );
};

export default AddSceneArtistsBox;

const MaterialSymbolCloseIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      aria-label="double headed arrow"
      role="img"
    >
      <path
        d="M6.4 19L5 17.6L10.6 12L5 6.4L6.4 5L12 10.6L17.6 5L19 6.4L13.4 12L19 17.6L17.6 19L12 13.4L6.4 19Z"
        fill="white"
      />
    </svg>
  );
};
